<prism-ui-page-template
  key-id="app-component-page-template"
  has-sidebar-left="false"
  [backgroundImage]="isInstructionsPage ? 'default-tall-blue' : ''"
  (mousemove)="onUserAction()"
  (keydown)="onUserAction()"
  (click)="onUserAction()"
  >
  <div slot="header">
    <app-navbar header></app-navbar>
  </div>
  <prism-ui-page-content
    key-id="app-component-content"
    slot="content"
    illustration-url="assets/illustrations/Illustration-Footer-Large-Mountains.svg"
    illustration-top="true"
    style="height: 100%;"
    >

    @if (cmInitialized) {
      <router-outlet></router-outlet>
    }
    <!--TODO: Implement a loading spinner with new Prism-->
  </prism-ui-page-content>

  <div slot="footer">
    @if (this.isStandardTheme) {
      <prism-ui-footer
        key-id="template-footer"
        [companyName]="companyName"
        >
        <prism-ui-link
          key-id="template-footer"
          href="https://www.standard.com/legal-privacy"
          font-size="xs"
          target="_blank"
          slot="legal"
        >Privacy & Legal</prism-ui-link>
      </prism-ui-footer>
    }
    @if (!this.isStandardTheme) {
      <prism-ui-footer
        key-id="template-footer"
        [companyName]="companyName"
        >
        <prism-ui-link
          key-id="template-footer"
          href="https://www.northwesternmutual.com/legal-information/"
          font-size="xs"
          target="_blank"
          slot="legal"
        >Privacy & Legal</prism-ui-link>
      </prism-ui-footer>
    }
  </div>
</prism-ui-page-template>

<prism-ui-modal key-id="cancel-modal" has-dark-overlay="true">
  <prism-ui-heading
    slot="modal-header"
    key-id="cancel-modal"
    font-size="sm"
    font-weight="strong"
    >{{modalContentHeading}}</prism-ui-heading
    >
    <prism-ui-copy
      slot="modal-body"
      key-id="cancel-modal"
      >
      {{modalContentBody}}
    </prism-ui-copy>
    <div slot="modal-footer">
      <div class="modalButtonStyling">
        <prism-ui-button
          button-width="full"
          key-id="cancel-button"
          size="md"
          variant="secondary"
          type="button"
          is-icon-right-aligned="false"
          (click)="onCancelModal('prism-ui-modal-cancel-modal')"
        >Cancel</prism-ui-button>
        <prism-ui-button class="leftPaddingSmall"
          button-width="full"
          key-id="continue-button"
          size="md"
          variant="primary"
          type="button"
          is-icon-right-aligned="false"
          (click)="leaveAnyway()"
        >Leave Anyway</prism-ui-button>
      </div>
    </div>
  </prism-ui-modal>

  <prism-ui-modal key-id="timer-modal" has-dark-overlay="true">
    <prism-ui-heading
      slot="modal-header"
      key-id="timer-modal"
      font-size="sm"
      font-weight="strong"
      >{{timerContentHeading}}</prism-ui-heading
      >
      <prism-ui-copy
        slot="modal-body"
        key-id="timer-modal"
        >
        {{timerContentBody}}
      </prism-ui-copy>
      <div slot="modal-footer">
        <div class="modalButtonStyling">
          <prism-ui-button
            button-width="content"
            key-id="cancel-button"
            size="md"
            variant="secondary"
            type="button"
            is-icon-right-aligned="false"
            (click)="EndSession()"
          >End Session Now</prism-ui-button>
          <prism-ui-button class="leftPaddingSmall"
            button-width="content"
            key-id="continue-button"
            size="md"
            variant="primary"
            type="button"
            is-icon-right-aligned="false"
            (click)="keepWorking()"
          >Continue to Work</prism-ui-button>
        </div>
      </div>
    </prism-ui-modal>

    <prism-ui-modal key-id="error-modal" has-dark-overlay="true">
      <prism-ui-heading
        slot="modal-header"
        key-id="error-modal"
        font-size="sm"
        font-weight="strong"
        >{{modalContentHeading}}</prism-ui-heading
        >
        <prism-ui-copy
          slot="modal-body"
          key-id="error-modal"
          >
          {{modalContentBody}}
        </prism-ui-copy>
        <div slot="modal-footer">
          <div class="modalButtonStyling">
            <prism-ui-button class="leftPadding"
              button-width="full"
              key-id="cancel-button"
              size="md"
              variant="secondary"
              type="button"
              is-icon-right-aligned="false"
              (click)="onCancelModal('prism-ui-modal-error-modal')"
            >Cancel</prism-ui-button>
            <prism-ui-button class="leftPaddingSmall"
              button-width="full"
              key-id="continue-button"
              size="md"
              variant="primary"
              type="button"
              is-icon-right-aligned="false"
              (click)="leaveAnyway()"
            >Leave Anyway</prism-ui-button>
          </div>
        </div>
      </prism-ui-modal>